import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../mobile.setup';
import {
  MobileSimAndLineManagementSimTab,
  MobileSimAndLineManagementLineTab,
} from './tabs';

const parent = Mobile.pages.simAndLineManagement;
const title = 'PAGE.MOBILE.SIM_AND_LINE_MANAGEMENT.TITLE';
const tabs: TabPermission[] = [
  MobileSimAndLineManagementSimTab,
  MobileSimAndLineManagementLineTab,
];

export const MobileSimAndLineManagementPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
